import FromValidation from '../modules/FromValidation';

// jQuery
(function ($) {
  $(function () {

    // Подключаем слайдеры Slick
    if ($('.promo-slider').length)
      $('.promo-slider').slick({
        slidesToShow: 1,
        dots: true,
        autoplay: true,
        autoplaySpeed: 8000,
      });

    if ($('.detail-page-slider__slider').length) $('.detail-page-slider__slider').slick({
      slidesToShow: 1,
      dots: true,
    });

    if ($('.detail-page-rating-slider').length) $('.detail-page-rating-slider').slick({
      slidesToShow: 3,
      dots: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            dots: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            dots: true,
          },
        },
      ],
    });

    if ($('.trainers-slider').length) $('.trainers-slider').slick({
      slidesToShow: 4,
      dots: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            dots: true,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            dots: true,
          },
        },
      ],
    });

    if ($('.photovideo-slider').length) $('.photovideo-slider').slick({
      slidesToShow: 3,
      dots: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            dots: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            dots: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            dots: true,
          },
        },
      ],
    });

    if ($('.reviews-slider').length) $('.reviews-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
          },
        },
      ],
    });

    if ($('.photo-video-sla').length) $('.photo-video-sla').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    if ($('.partners').length) $('.partners-slider').slick({
      slidesToShow: 6,
      slidesToScroll: 6,
      dots: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
          },
        },
      ],
    });

    if ($('.license-blocks').length) $('.license-blocks').slick({
      slidesToShow: 4,
      dots: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            dots: true,
          },
        },

      ],
    });

    if ($('.partners-items.row').length) $('.partners-items.row').slick({
      slidesToShow: 4,
      dots: true,
      responsive: [
        {
          breakpoint: 20000,
          settings: 'unslick',
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            dots: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            dots: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            dots: true,
          },
        },
      ],
    });

    if ($('.page-filter-wrap').length) $('.page-filter-wrap').slick({
      slidesToShow: 4,
      dots: false,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 460,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });

    if ($('.photo-video-sl').length) $('.photo-video-sl').slick({
      responsive: [
        {
          breakpoint: 99999,
          settings: 'unslick',
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            dots: false,
          },
        },
        {
          breakpoint: 460,
          settings: {
            slidesToShow: 1,
            dots: false,
          },
        },
      ],
    });


    //Всплывашки Fancybox
    console.log($('.popupbutton'));
    if ($('.popupbutton').length) $('.popupbutton').fancybox({
      'padding': 37,
      'overlayOpacity': 0.87,
      'overlayColor': '#ffffff',
      'transitionIn': 'none',
      'transitionOut': 'none',
      'titlePosition': 'inside',
      'centerOnScroll': true,
      'maxWidth': 840,
      'minHeight': 110,
      ajax: {
        settings: {
          data: {isNaked: 1},
        },
      },
      afterLoad () {
        new FromValidation().render();
      },
    });

    $('a.gallery').fancybox({
      'padding': 0,
      'overlayOpacity': 0.87,
      'overlayColor': '#ffffff',
      'transitionIn': 'none',
      'transitionOut': 'none',
      'titlePosition': 'inside',
      'centerOnScroll': true,
      'maxWidth': 840,
      'minHeight': 110,
    });

    $('.grouped_elements').fancybox();

    $('.video_gal').fancybox({
      'padding': 0,
      'overlayOpacity': 0.87,
      'overlayColor': '#ffffff',
      'transitionIn': 'none',
      'transitionOut': 'none',
      'titlePosition': 'inside',
      'centerOnScroll': true,
      'maxWidth': 620,
      'maxHeight': 360,
    });

    /*
    $('a.goto-photo').click(function(){
        var text = $(this).text();
        $(this).hide().closest('.page-section-blocks').children('.photo-video-sl').children('.hiddens').slideToggle();
        return false;
    })
    */

    $('a.goto-video').click(function () {
      $(this).hide().closest('.page-section-blocks').children('.photo-video-sl').children('.hiddens').slideToggle();
      return false;
    });

    $('#all-partners').click(function () {
      $('.partners-content-item.item--hidden').slideToggle();
      $(this).fadeOut();
      return false;
    });

    setTimeout(function () {
      $('input:not(.no-styler), select:not(.no-styler)').styler();
    }, 500);

    //

    $('.page-contacts-cash__title').click(function () {
      $(this).siblings('.page-contacts-cash__p').toggle();
      $(this).parents('.page-contacts-cash-item').toggleClass('tt');
      console.log('');
    });

    //

    $('.header-menu').click(function () {
      var mtext = $(this).children('.header-menu-block').attr('style');
      if (mtext == 'display: none;') {
        $(this).children('.header-menu-block').attr('style', 'display: flex;');
      }else {
        $(this).children('.header-menu-block').attr('style', 'display: none;');
      }
    });

    // Маска телефон
    $('input[type=\'phone\']').mask('+7 (999) 999 99 99');

    //
    $('ul.tabs__caption_base').each(function () {
      $(this).children('li.a').each(function (i) {
        $(this).click(function () {
          $(this).addClass('active').siblings().removeClass('active').parents().siblings('div.tabs__content').removeClass('active').eq(i).addClass('active');
        });
      });
    });

    $('ul.tabs__caption_sub').each(function () {
      $(this).children('li.b').each(function (z) {
        $(this).click(function () {
          $(this).addClass('active').siblings().removeClass('active').parents().siblings('div.tabs__content2').removeClass('active').eq(z).addClass('active');
        });
      });
    });

    var reviewsslider = $('.reviews-slider .slick-dots > li').length;
    console.log(reviewsslider);
    if (reviewsslider == '1') {
      $('.reviews-slider .slick-dots > li').hide();
    }

    var partnersslider = $('.partners-slider .slick-dots > li').length;
    console.log(partnersslider);
    if (partnersslider == '1') {
      $('.partners-slider .slick-dots > li').hide();
    }

    var trainsersslider = $('.trainers-slider .slick-dots > li').length;
    console.log(trainsersslider);
    if (trainsersslider == '1') {
      $('.trainers-slider .slick-dots > li').hide();
    }


    //Если меньше трех слайдов, правим слайдер фильтрации для фото и видео блоков
    var slidenum = $('.photo-section--title .page-filter__link').length;
    // console.log(slidenum);
    if (slidenum <= '3') {
      $('.photo-section--title').addClass('small');
    }

    var slidenum = $('.video-section--title .page-filter__link').length;
    // console.log(slidenum);
    if (slidenum <= '3') {
      $('.video-section--title').addClass('small');
    }

    $(function () {
      setTimeout(function () {
        var maxHeight = 0;

        $('.detail-page-po-item__link').each(function () {
          if ($(this).height() > maxHeight) {
            maxHeight = $(this).height();
            console.log('s');
          }
        });

        $('.detail-page-po-item__link').height(maxHeight);

      }, 200);
    });

    $(document).on('click', function (e) {
      if (!$(e.target).closest('.header-menu').length) {
        $('.header-menu-block').hide();
      }
      e.stopPropagation();
    });

  });
})(jQuery);
